import { render, staticRenderFns } from "./Vorstand.vue?vue&type=template&id=3cf6f186&scoped=true&"
import script from "./Vorstand.vue?vue&type=script&lang=js&"
export * from "./Vorstand.vue?vue&type=script&lang=js&"
import style0 from "./Vorstand.vue?vue&type=style&index=0&id=3cf6f186&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf6f186",
  null
  
)

export default component.exports